import { render, staticRenderFns } from "./AIHelper.vue?vue&type=template&id=fddfc812&scoped=true"
import script from "./AIHelper.vue?vue&type=script&lang=js"
export * from "./AIHelper.vue?vue&type=script&lang=js"
import style0 from "./AIHelper.vue?vue&type=style&index=0&id=fddfc812&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddfc812",
  null
  
)

export default component.exports